import { SInvisibleFileInput } from './ImagePicker.styled'
import React, { forwardRef, InputHTMLAttributes } from 'react'
import { toastError } from 'components/Toast'

export const ImagePickerHidden = forwardRef<
  HTMLInputElement,
  React.DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> & {
    sizeLimit?: number
    onFileSelect?: (value?: File) => void
  }
>(({ onFileSelect, sizeLimit, ...props }, ref) => {
  const handleChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.currentTarget?.files?.[0]) {
      const newFile = e.currentTarget.files[0]
      if (sizeLimit && newFile.size > sizeLimit) {
        toastError('file_too_big')
        return
      }
      onFileSelect?.(newFile)
    }
  }

  return (
    <SInvisibleFileInput
      {...props}
      onChange={handleChange}
      ref={ref}
      type="file"
      accept="image/*"
    />
  )
})
ImagePickerHidden.displayName = 'ImagePickerHidden'
